/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementReadLiveCsvResponse } from './LiveManagementReadLiveCsvResponse';

export type LiveManagementReadLiveCsvResponseApiRespoonse = {
    data?: LiveManagementReadLiveCsvResponse;
    status?: LiveManagementReadLiveCsvResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementReadLiveCsvResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

